import { ReactNode, createContext, useContext } from 'react';
import * as React from 'react';

import { useGenerateQuestions } from '~teacher/hook/ai';

const GenerateQuestionContext =
  createContext<ReturnType<typeof useGenerateQuestions>>(null);

export function QuestionGeneratorContext({
  children,
}: {
  children: ReactNode;
}) {
  const generateQuestions = useGenerateQuestions();
  return (
    <GenerateQuestionContext.Provider value={generateQuestions}>
      {children}
    </GenerateQuestionContext.Provider>
  );
}

export function useQuestionGenerator() {
  const generateQuestionMutation = useContext(GenerateQuestionContext);
  if (!generateQuestionMutation) {
    throw new Error(
      'useQuestionGenerator must be used inside QuestionGeneratorContext'
    );
  } else {
    return generateQuestionMutation;
  }
}
